export default __webpack_public_path__ + "static/media/poster_fund.53dd0f22.jpg";